import PropTypes from 'prop-types';
import PreviewFilePDF from './PreviewFilePDF';
import PreviewFileImage from './PreviewFileImage';
import Loading from 'Components/Atoms/Loading/Loading';
import clsx from 'clsx';
import classes from './PreviewFile.module.css';
import { isPDF } from 'Utils/files';

export default function PreviewFile({ url, loading = false, className, onDownload, onPrint }) {
    if (loading) {
        return (
            <div className={clsx(classes.loading, className)}>
                <Loading />
            </div>
        );
    }

    const Component = isPDF(url) ? PreviewFilePDF : PreviewFileImage;

    return <Component url={url} className={className} onDownload={onDownload} onPrint={onPrint} />;
}

PreviewFile.propTypes = {
    url: PropTypes.string,
    className: PropTypes.string,
    loading: PropTypes.bool,
    onDownload: PropTypes.func,
    onPrint: PropTypes.func,
};
